import { validaSoloNumero } from "@/util/varios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

export default function ModalImprimirDeudasContribuyentes(props) {
  const op = require("@/modulos/datos");
  const anioActual = new Date().getFullYear();
  const [orden, setOrden] = useState("ASC");
  const [metodoOrden, setMetodoOrden] = useState("codigo");
  const [declarados, setDeclarados] = useState(false);
  const [fechas, setFechas] = useState({
    desde: `${anioActual}-01-01`,
    hasta: new Date().toISOString().split("T")[0],
  });
  const [monto, setMonto] = useState(0);
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    const { value } = event.target;
    setMonto(value);
  };
  const imprimirReporte = () => {
    window.open(
      `${op.reportes}/actividadeconomica?reporte=ListaContribuyenteUltiDeclara&desde='${fechas.desde}'&hasta='${fechas.hasta}'&monto=${monto || 0}&ordenar_por=${metodoOrden}&orden=${orden}&declarados=${declarados}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const blanquear = () => {
    setFechas({
      desde: `${anioActual}-01-01`,
      hasta: new Date().toISOString().split("T")[0],
    });
    setMonto(0);
    setOrden("ASC");
    setMetodoOrden("codigo");
    setDeclarados(false)
  };
  const salir = () => {
    props.setShow();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Imprimir Listado Detallado de Contribuyente
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto">Buscar Comercios</legend>
            <div className="row col-md-6 mx-auto d-flex justify-content-center">
              <div className="form-check col-md-6">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="buscar"
                  value="true"
                  id="sinDelcarar"
                  checked={!declarados}
                  onChange={() => {
                    setDeclarados(!declarados);
                  }}
                />
                <label
                  className="form-check-label my-auto"
                  htmlFor="sinDelcarar"
                >
                  Sin Declarar
                </label>
              </div>
              <div className="form-check col-md-3">
                <input
                  className="form-check-input my-auto"
                  type="radio"
                  name="buscar"
                  value="true"
                  id="declarados"
                  checked={declarados}
                  onChange={() => {
                    setDeclarados(!declarados);
                  }}
                />
                <label
                  className="form-check-label my-auto"
                  htmlFor="declarados"
                >
                  Declarados
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto">
              Filtros de Ordenamiento
            </legend>
            <div className="input-group input-group-sm mb-2 col-md-5">
              <span className="input-group-text">Ordenar Por:</span>
              <select
                className="form-select form-select-sm"
                value={metodoOrden}
                onChange={(e) => {
                  setMetodoOrden(e.target.value);
                }}
              >
                <option value="codigo">Código</option>
                <option value="nombre">Nombre</option>
                <option value="direccion">Dirección</option>
                <option value="fechainscripcion">Fecha de Inscripción</option>
                <option value="fechadeclaracion">
                  Fecha Ultima Declaración
                </option>
                <option value="fechadeclaracion">Fecha Ultimo Pago</option>
                <option value="mto_periodo">Monto de la Deuda</option>
              </select>
            </div>
            <div className="input-group input-group-sm mb-2 col-md-5">
              <span className="input-group-text">Metodo de Ordenamiento:</span>
              <select
                className="form-select form-select-sm"
                value={orden}
                onChange={(e) => {
                  setOrden(e.target.value);
                }}
              >
                <option value="ASC">Ascendente</option>
                <option value="DESC">Descendente</option>
              </select>
            </div>
          </fieldset>
          <fieldset className="row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto">Filtros de Busqueda</legend>
            <div className="row mx-auto py-2">
              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  {"Monto Deuda >= a : "}
                </span>
                <input
                  type="text"
                  onChange={handleInputNumChange}
                  className="form-control text-right"
                  value={monto}
                />
              </div>
              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Desde:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.desde}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      desde: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Hasta:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.hasta}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      hasta: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => blanquear()}
          className="btn-sm rounded-pill btn btn-warning col-md-2"
        >
          <i className="fa fa-trash"></i> Limpiar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
}
